import { IconMantangLogo } from '@/assets/svgs';

const LoginHero = () => {
	return (
		<div className="flex min-h-0 flex-1 flex-col items-center justify-center px-5 py-10 text-center">
			<IconMantangLogo className="ml-[5vh] h-[15vh] w-auto shrink-0" />
			<h1 className="mt-7 font-wavepado text-5xl text-mantang-gray-900">
				만땅
			</h1>
			<p className="mt-5 text-mantang-gray-500 leading-8">
				가까운데 비싼 곳, 먼데 싼 곳 고민이셨죠?
			</p>
			<p className="text-mantang-gray-500 leading-8">
				더 이득인 주유소, 만땅이 찾아드릴게요
			</p>
		</div>
	);
};

export default LoginHero;
